module.exports = __webpack_public_path__ + "static/img/default.edd21fc6.jpg";